import { render, staticRenderFns } from "./HistoryMinibusRequest.vue?vue&type=template&id=4a07a727&"
import script from "./HistoryMinibusRequest.vue?vue&type=script&lang=js&"
export * from "./HistoryMinibusRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports